import {Box} from '@mui/material';
import {MDXProvider} from '@mdx-js/react';
import {PropsWithChildren} from 'react';
import {mdxComponents} from './MdxComponents.tsx';

export const ManualArticle: React.FC<PropsWithChildren> = ({children}) => (
  <MDXProvider components={mdxComponents}>
    <Box
      component="article"
      sx={{
        maxWidth: 820,
        mx: 'auto',
        px: {xs: 2, sm: 3},
        py: 4,
        color: 'text.primary',
      }}
    >
      {children}
    </Box>
  </MDXProvider>
);
